import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../basequery";
import { AxiosResponse } from "axios";
import { SowTemplate } from "@typings/sow-template";
import { CRMProduct } from "@typings/project-type";
import { CRMServiceGroup } from "@typings/service-group";

export interface ValueLabelOption {
  value: string;
  label: string;
}

export interface GetServiceGroupsResponse {
  data: CRMServiceGroup[];
}

export interface GetProjectTypeOptionsResponse {
  data: {
    data: Array<{
      name: string;
      id: string;
      servicegroup: string;
      servicegroupid: string;
      status: number;
      workdayprojectid: string;
    }>;
  };
}

export const optionsApi = createApi({
  reducerPath: "optionsApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Options"],
  endpoints: (builder) => ({
    getProjectTypeOptions: builder.query<AxiosResponse<{
      data: CRMProduct[];
    }>, void>({
      query: () => ({
        url: "options/crm-project-types",
        method: "GET",
      }),
    }),
    getSowTemplates: builder.query<
      AxiosResponse<{
        count: number;
        data: SowTemplate[];
      }>,
      { serviceGroup?: string }
    >({
      query: ({ serviceGroup }: { serviceGroup?: string }) => ({
        url: "options/sow-templates",
        method: "GET",
        params: { servicegroup: serviceGroup },
      }),
    }),
    getServiceGroups: builder.query<AxiosResponse<GetServiceGroupsResponse>, void>({
      query: () => ({
        url: "options/service-groups",
        method: "GET",
      }),
      providesTags: ["Options"],
    }),
  }),
});

export const {
  useGetSowTemplatesQuery,
  useGetProjectTypeOptionsQuery,
  useGetServiceGroupsQuery,
  useLazyGetServiceGroupsQuery,
} = optionsApi;

export default optionsApi;
